import React from "react";
import Modal from "../../components/Modal";
import { useTranslation } from "react-i18next";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import ContactsForm from "../../forms/account/ContactsForm";
import EditSupportContainer from "../../containers/support/EditSupportContainer";

const Edit = ({ handleClose, open, contacts }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <Modal
      fullScreen={matches}
      open={open}
      onClose={handleClose}
      title={t("register.title_edit_contacts")}
    >
      {contacts ? (
        <EditSupportContainer support={contacts}>
          {({ onSubmit, support }) => (
            <ContactsForm onSubmit={onSubmit} initialValues={support.profile} />
          )}
        </EditSupportContainer>
      ) : null}
    </Modal>
  );
};

export default Edit;
